import React from 'react';
export function Footer() {
  return <footer className="bg-brand-dark text-gray-500 py-6 px-4 border-t border-white/10" data-id="element-97">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-98">
        <div className="inline-block bg-brand-accent text-brand-dark font-black px-3 py-1 rounded-full mb-3 text-[10px] tracking-widest uppercase" data-id="element-99">
          🏋️ KIT COMPLETO ENTRENAMIENTO FUNCIONAL LISTO
        </div>

        <p className="text-xs md:text-sm font-medium mb-2 max-w-xl text-gray-400 leading-snug" data-id="element-100">
          El sistema de planificación más completo para entrenadores funcionales
          del mundo hispanohablante. De México a Argentina. Principiantes,
          intermedios y avanzados.
        </p>

        <p className="text-xs mb-4 italic text-gray-600 font-medium" data-id="element-101">
          Porque entrenar bien no debería costarte todos los fines de semana del
          año.
        </p>

        <div className="w-full border-t border-white/5 pt-4 text-[10px] text-gray-600 font-medium" data-id="element-102">
          <p data-id="element-103">
            © Kit Completo Entrenamiento Funcional Listo — Todos los derechos
            reservados
          </p>
        </div>
      </div>
    </footer>;
}